<template>
  <div style="background: #F2F5F8; width: 100%; padding: 20px;box-sizing:border-box; max-width: 620px; margin: 0 auto;">
    <img src="https://www-test.choicedigitalbank.com/logo.png" alt="" style="height: 26px;" />

    <div style="background: #fff; border-radius: 10px; padding: 22px 30px; margin-top: 20px;">
      

    </div>


    <div style="color: #797878;font-size: 14px; font-weight: 400; line-height: 18px; padding: 27px 0 36px;">
      <span style="font-weight: 700;">IMPORTANCE NOTICE:</span> The information in this email (and any attachments) is confidential. If you are not the intended recipient, you must not use or disseminate the information. If you have received this email in error, please permanently delete the original and any copies or printouts thereof immediately. Although this email and any attachments are believed to be free of any virus or other defect that might affect any computer system into which it is received and opened, it is the responsibility of the recipient to ensure that it is virus free and no responsibility is accepted by Choice Microfinance Bank, for any loss or damage arising in any way from its use.
    </div>

    <div style="width: 300px; margin: 0 auto;">
      <a href="https://app.choicedigitalbank.com/#/privacypolicy" style="color: #797878; text-align: center; font-size: 12px;font-weight: 400;text-decoration-line: underline; display: inline-block; vertical-align: middle;">Privacy policy</a>
      <span style="width: 4px; height: 4px; border-radius: 4px; display: inline-block; vertical-align: middle; margin: 0 5px;background: #D9D9D9"></span>
      <a href="https://app.choicedigitalbank.com/#/conditions" style="color: #797878; text-align: center; font-size: 12px;font-weight: 400;text-decoration-line: underline; display: inline-block; vertical-align: middle;">Terms of service</a>
      <span style="width: 4px; height: 4px; border-radius: 4px; display: inline-block; vertical-align: middle; margin: 0 5px;background: #D9D9D9"></span>
      <a href="https://choice-bank.com/contact-us" style="color: #797878; text-align: center; font-size: 12px;font-weight: 400;text-decoration-line: underline; display: inline-block; vertical-align: middle;">Help center</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseUrl: window.location.origin
    };
  },
};
</script>